'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import SupportToolsController from "./controller/supportTools";
import SupportToolModalCreateController from "./controller/supportToolModalCreate";
import SupportToolTableDirective from "./directive/supportToolTable";
import SupportToolService from "./service/supportTool";

export default angular.module('investmentProject.supportTool', [])
    .controller('SupportToolsController', SupportToolsController)
    .controller('SupportToolModalCreateController', SupportToolModalCreateController)
    .directive('supportToolTable', SupportToolTableDirective)
    .factory('SupportToolService', SupportToolService)
    .name;